import * as Yup from 'yup';

export default Yup.object().shape({
  currentKamId: Yup.string(),
  newKamId: Yup.string().required('SCHEMA_ERRORS.NEW_KAM_REQUIRED')
});
